import { ErrorHandler } from '../../globals/classes/errorHandler';
import { IErrorDescription } from '@ibank-globals/error';
import { BaseComponent } from '../../globals/classes/base.component';
import { SourceApis } from '../../globals/classes/errorDescription';

export abstract class ComponentWithErrors extends BaseComponent {
	public handleError(error?: IErrorDescription) {
		ErrorHandler.newError(error);
	}

	public handleApiError(error: IErrorDescription, sourceApi: SourceApis) {
		ErrorHandler.newError(error, sourceApi);
	}

	public handlePassError(isLoginError?: boolean) {
		if (isLoginError) {
			let err: IErrorDescription = { desc: 'OldPasswordWentWrong' };
			ErrorHandler.newError(err);
		} else return;
	}
}
